/* FG menu A "Curtain": red line under the active top item, Escape returns focus, phone drawer tabs.
   Open/close itself stays with Hyper's details-mega (header.js). */
(() => {
  const nav = document.querySelector('.header__menu > ul');
  if (nav) {
    const line = document.createElement('span');
    line.className = 'fg-curtain-line';
    line.setAttribute('aria-hidden', 'true');
    nav.appendChild(line);
    let leaveTimer;
    const moveTo = (li) => {
      const label = li && li.querySelector('summary .menu__item-text, a.menu__item > .reversed-link, a');
      if (!label) return;
      const base = (line.offsetParent || document.body).getBoundingClientRect();
      const box = label.getBoundingClientRect();
      line.style.transform = `translate(${box.left - base.left}px, ${box.bottom - base.top + 6}px) scaleX(${box.width})`;
      line.classList.add('is-on');
    };
    const settle = () => {
      // details.open is Hyper's live state; the [open] attribute lingers until the close animation ends
      const open = [...nav.querySelectorAll(':scope > li > details')].find((d) => d.open === true);
      if (open) moveTo(open.closest('li'));
      else line.classList.remove('is-on');
    };
    const topLi = (el) => {
      let li = el.closest('li');
      while (li && li.parentElement !== nav) li = li.parentElement.closest('li');
      return li;
    };
    nav.addEventListener('mouseover', (e) => {
      const li = topLi(e.target);
      if (li) { clearTimeout(leaveTimer); moveTo(li); }
    });
    nav.addEventListener('focusin', (e) => {
      const li = topLi(e.target);
      if (li) { clearTimeout(leaveTimer); moveTo(li); }
    });
    nav.addEventListener('mouseleave', () => { leaveTimer = setTimeout(settle, 260); });
    nav.addEventListener('focusout', () => { leaveTimer = setTimeout(settle, 260); });
  }

  // Escape inside a Curtain panel: move focus to its top button before Hyper's own handler closes the panel.
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const menu = e.target.closest && e.target.closest('details.fg-curtain[open]');
    if (menu && e.target !== menu.firstElementChild) menu.firstElementChild.focus();
  }, true);

  if (!customElements.get('fg-curtain-tabs')) {
    customElements.define('fg-curtain-tabs', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.select(i));
          tab.addEventListener('keydown', (e) => {
            const step = { ArrowRight: 1, ArrowLeft: -1 }[e.key];
            if (e.key === 'Home' || e.key === 'End') {
              e.preventDefault();
              this.select(e.key === 'Home' ? 0 : this.tabs.length - 1, true);
            } else if (step) {
              e.preventDefault();
              this.select((i + step + this.tabs.length) % this.tabs.length, true);
            }
          });
        });
      }
      select(index, focus) {
        this.tabs.forEach((tab, i) => {
          const on = i === index;
          tab.setAttribute('aria-selected', on);
          tab.tabIndex = on ? 0 : -1;
          document.getElementById(tab.getAttribute('aria-controls')).hidden = !on;
        });
        const tab = this.tabs[index];
        if (focus) tab.focus();
        tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    });
  }
})();
